import Lottie from "lottie-react";

import styles from "./loader.module.scss";
// import loader6 from "../../../styles/images/l6.json";
import loader6 from "../../../components/loader/worktual-loader.json";
import Loaderlist from '../../../../src/styles/images/loader.gif';


const Loader = () => {
  return (
    <div className={`${styles.mainLoadercontainer} loaders`}>
      {/* <Lottie
        className="svgLoadinglistcenter"
        animationData={loader6}
        style={{ width: 100 }}
      /> */}
        <img src={Loaderlist} alt="Loader" className="loadermain" />
    </div>
  );
};

export default Loader;
